import { SKELETON_KEY } from './skeletonFactory';

export function skeletonReader() {
  return {
    id: SKELETON_KEY,
    name: SKELETON_KEY,
    ftpConfiguration: SKELETON_KEY
  };
}
